// extracted by mini-css-extract-plugin
module.exports = {"qty":"styles_qty__KrsrE","qty_sm":"styles_qty_sm__G6TqY","loader":"styles_loader__SPOtX","loaderWrapper":"styles_loaderWrapper__5hM59"};